import {z} from "zod/v4";
import {InfallibleUseResult, pendingUseResult, successUseResult} from "../util/hookutil.tsx";
import {useSelf} from "../agent/useSelf.ts";

export const HomeVenue = z.object({
    venueId: z.string(),
    isAdmitting: z.optional(z.boolean()),
    isInspecting: z.optional(z.boolean()),
    isSupervising: z.optional(z.boolean()),
});
export type HomeVenue = z.infer<typeof HomeVenue>;

export function useHomeVenue(): InfallibleUseResult<HomeVenue | null> {
    const {data: self, isPending: isSelfPending} = useSelf();

    if (isSelfPending) {
        return pendingUseResult;
    }

    if (self.admitterFor) {
        return successUseResult({
            venueId: self.admitterFor.id,
            isAdmitting: true,
        } as const);
    }
    if (self.inspectorFor) {
        return successUseResult({
            venueId: self.inspectorFor.id,
            isInspecting: true,
        });
    }
    if (self.supervisorFor) {
        return successUseResult({
            venueId: self.supervisorFor.id,
            isSupervising: true,
        });
    }

    return successUseResult(null);
}

